import { Col, message, Row } from 'antd';
import { Routes } from 'config/routes';
import { NotificationPayloadOutput } from 'gql/types';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type PropTypes = {
  payload: NotificationPayloadOutput;
};

const RequestCreated: FC<PropTypes> = ({ payload }) => {
  const { t } = useTranslation('notification.NotificationCard.RequestCreated');
  const request = payload.request;
  const currentUser = useCurrentUser();

  if (!request) {
    return null;
  }

  const hasApprovalPermission =
    currentUser.data?.permissions?.approveDisapproveRequests === true;

  const handleClick = (e: React.MouseEvent) => {
    if (!hasApprovalPermission) {
      e.preventDefault();
      message.warning(t('noPermissionToApprove'));
    }
  };

  return (
    <Row align="middle">
      <Col>{t('requestCreated')}&nbsp;</Col>
      <Col>
        <Link
          to={Routes.Request.replace(':id', request.id)}
          onClick={handleClick}
        >
          {t('processRequest')}
        </Link>
      </Col>
    </Row>
  );
};

export default RequestCreated;
